declare global {
    interface Window {
        web3Plugin: any;
        web3ChainId: any;
        auth: any;
        googleProvider: any;
        facebookProvider: any;
        firebase: any;
    }
}

import {
    OFSetChainId,
    OFGetChainId,
    OFGetOpenfort,
    OFsendTransaction,
    OFauthenticateWithThirdPartyProvider,
    OFgetEmbeddedState,
    OFsetAutomaticRecoveryMethod,
    OFlogout,
    OFsignMessage,
    OFInitialize,
    OpenRamp,
} from "./openfort";

import { Modal, ModalOptions } from "flowbite";

import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/messaging";
import "firebase/compat/analytics";
import { Chain, parseUnits } from "viem"

let chainNames: string[] = [];
const _chainNamesMainnet = ["saakuru", "binance", "ronin"];
const _chainNamesTestnet = ["saakuruTestnet", "binanceTestnet", "roninTestnet"];
const getChainIdByName = (selectedName: string) => {
    for (let i = 0; i < chainNames.length; i++) {
        if (chainNames[i].includes(selectedName)) {
            // selectedName 은 saakuru, binance 만 있음
            // dev, live 에 따른 구분
            const cname = chainNames[i];
            if (cname === "saakuru")         return "7225878";
            if (cname === "saakuruTestnet")  return "247253";
            if (cname === "binance")         return "56";
            if (cname === "binanceTestnet")  return "97";
            if (cname === "ronin")  return "2020";
            if (cname === "roninTestnet")  return "2021";
            break;
        }
    }
    return "7225878"; // default saakuru, 여기까지 오면 안됨
}

const getChainNameById = (chainId: string) => {
    if (chainId === "7225878")  return "saakuru";
    if (chainId === "247253")   return "saakuruTestnet";
    if (chainId === "56")       return "binance";
    if (chainId === "97")       return "binanceTestnet";
    if (chainId === "2020")       return "ronin";
    if (chainId === "2021")       return "roninTestnet";
         
    return "saakuru";
}

const getGasPrice = () => {
    if (window.web3ChainId === 56 || window.web3ChainId === 97) {
        return undefined;// BigInt(5000000000);
    }
    if (window.web3ChainId === 2020 || window.web3ChainId === 2021) {
        return undefined;// BigInt(5000000000);
    }
    if (window.web3ChainId === 7225878 || window.web3ChainId === 247253) {
        return BigInt(0);
    }
    return BigInt(0);
}

window.firebase = firebase;


// load web3gl to connect to unity
window.web3Plugin = {
    networkId: 0,
    _connectWallet,
    _connectAccount: "",
    _disconnectAccount,
    _disconnectAccountResponse: "",
    _signMessage,
    _signMessageResponse: "",
    _callContract,
    _callContractResponse: "",
    _sendContract,
    _sendContractResponse: "",
    _openInputModal,
    _openInputModalResponse: "",
    _fcmToken: "",
    _openfortProc,
    _walletProvider: "",
    _linkedAddress: "",
    _openRamp: OpenRamp,
    _initChainNames: InitChainNames,
    _getBrowserChainId: GetBrowserChainId,
    _getBrowserChainIdResponse: "",
    _switchBrowserChain: switchBrowserChain,
};

console.log("web3gl", window.web3Plugin)

// 0. Import wagmi dependencies
// import { bsc, bscTestnet } from "@wagmi/core/chains";
import { saakuru, saakuruTestnet } from "./chains";
import { bsc as binance, bscTestnet as binanceTestnet } from "./chains";
import { ronin, saigon as roninTestnet } from '@wagmi/core/chains';

import {
    createConfig,
    http,
    connect,
    reconnect,
    disconnect as v2disconnect,
    watchAccount,
    getAccount,
    getBalance,
    switchChain,
    simulateContract,
    writeContract as v2writeContract,
    waitForTransactionReceipt,
    signMessage as v2signMessage,
    readContract as v2readContract
} from "@wagmi/core";

import { injected, walletConnect } from "@wagmi/connectors";

const supportedChains: any = [saakuru, saakuruTestnet, binance, binanceTestnet, ronin, roninTestnet];

// 1. Define chains
const v2config = createConfig({
    chains: supportedChains,
    connectors:[
        // metaMask(), // metamask SDK , injected 가 제대로 안될 경우 고려
        walletConnect({
            projectId: 'd364ce84579757b8f0ac19772c349464'
        }),
        injected({
            target: 'metaMask',
            shimDisconnect: false
        })

    ],
    transports: {
        [saakuru.id]: http(),
        [saakuruTestnet.id]: http(),
        [binance.id]: http(),
        [binanceTestnet.id]: http(),
        [ronin.id]: http(),
        [roninTestnet.id]: http(),
    },

});

const wagmiGetAccount = () => {
    return getAccount(v2config);
}

const getNetwork = () => {
    const chains = v2config.chains;
    const { chainId } = getAccount(v2config);
    const chain = chains.find((ch: any) => ch.id === chainId);

    return { chain, chains };
}

const fetchBalance = (options: any) => {
    return getBalance(v2config, options);
}

const prepareWriteContract = async (options: any) => {
    try {

        let { request } = await simulateContract(v2config, options);
        return { request };
    } catch (error) {
        console.log("simulate error start")
        console.log(error)
        console.log("simulate error end")
        throw error
    }
}

const writeContract = async (options: any) => {
    let hash = await v2writeContract(v2config, options);
    return { hash };
}

const waitForTransaction = async (options: any) => {
    return await waitForTransactionReceipt(v2config, options);
}

const disconnect = async () => {
    return await v2disconnect(v2config);
}

const signMessage = async (options: any) => {
    return await v2signMessage(v2config, options);
}

const readContract = async (options: any) => {
    return await v2readContract(v2config, options);
}

let _MetaMaskConnector = {
    options: {
        shimDisconnect: false
    }
}

// ================================================================
// >> Connect Wallet Modal
const walletModal = document.querySelector("#crypto-modal");
// options with default values
const options: ModalOptions = {
    placement: 'center',
    backdropClasses: 'bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40',
    onHide: () => {
        console.log('modal is hidden');
        if (window.web3Plugin._walletProvider == "openfort") {
            console.log("===== onHide() OPENFORT PASS")
            return;
        }
        const account = wagmiGetAccount();
        if (isClickModalButton == false && (account == null || account === undefined || account?.isConnected == false))
            window.web3Plugin._connectAccount = "Error1";
        /*
        if(typeof web3 === 'undefined' )
        {
          window.web3Plugin._connectAccount = "Error";
        }
        else
        {
          let result = web3.utils.isAddress(window.web3Plugin._connectAccount)
          console.log("web3.utils.isAddress : " + result);
          if(result == "false")
            window.web3Plugin._connectAccount = "Error";
        }    
        */
    },
    onShow: () => {
        console.log('modal is shown');
    },
    onToggle: () => {
        console.log('modal has been toggled');
    }
};

const WalletSelectModal = new Modal(walletModal as HTMLElement, options);

const ModalCloseButton = document.querySelector("#ModalCloseButton")!;
ModalCloseButton.addEventListener('click', () => {
    console.log("Click1");
    window.web3Plugin._connectAccount = "Error2";
    WalletSelectModal.toggle();
})

// >> Modal Buttons
var isClickModalButton = false;
const select_chainId = document.querySelector("#select_chainId") as HTMLSelectElement;
const connectButton_MetaMask = document.querySelector("#ConnectWallet_MetaMask")!;
connectButton_MetaMask.addEventListener('click', () => {
    if (select_chainId.style.visibility === "visible")
    {
        const chainId = getChainIdByName(select_chainId.value);
        console.log("#1 Select:", select_chainId.value, chainId);
        window.web3ChainId = chainId;
    }

    isClickModalButton = true;
    connect_Wagmi('MetaMask');
})
const connectButton_WalletConnect = document.querySelector("#ConnectWallet_WalletConnect")!;
connectButton_WalletConnect.addEventListener('click', () => {
    if (select_chainId.style.visibility === "visible")
    {
        const chainId = getChainIdByName(select_chainId.value);
        console.log("#2 Select:", select_chainId.value, chainId);
        window.web3ChainId = chainId;
    }

    isClickModalButton = true;
    connect_Wagmi('WalletConnect');
})
const connectButton_Openfort = document.querySelector("#ConnectWallet_Openfort")!;
connectButton_Openfort.addEventListener('click', async () => {

    if (select_chainId.style.visibility === "visible")
    {
        const chainId = getChainIdByName(select_chainId.value);
        console.log("#3 Select:", select_chainId.value, chainId);
        if ((chainId === "7225878" || chainId === "247253") === false) {
            // saakuru, saakuruTestnet 만 가능
            return alert("Openfort only supports saakuru and saakuruTestnet");
        }
        window.web3ChainId = chainId;
    }

    OFSetChainId(window.web3ChainId, setWatchAccount, unwatchAccount);
    const openfortChainId = OFGetChainId();
    console.log({ openfortChainId });

    isClickModalButton = true;
    await connect_Openfort();
})
// << Modal Buttons
// << Connect Wallet Modal
// ================================================================

async function _connectWallet(chainId: any, showChains: boolean) {

    // TODO : 분리요망, 지갑 연결 과 지갑 선택 화면에 중복 사용으로 혼란을 가져옴
    // 더구나 어떤 목적으로 불리는지 변수가 없어서 알 수가 없음
    if (window.web3Plugin._linkedAddress == "" || window.web3Plugin._walletProvider == "openfort") {
        await _resetWeb3("", "");
    }

    isClickModalButton = false;
    const account = wagmiGetAccount();
    window.web3ChainId = chainId;

    if (account == null || account === undefined || account?.isConnected == false) {
        console.log("connect() >> window.web3ChainId : " + window.web3ChainId);
        console.log({showChains});
        if (showChains) {
            select_chainId.style.visibility = "visible";
        } else {
            select_chainId.style.visibility = "hidden";
        }
        WalletSelectModal.toggle();
    }
    else {
        if (account != null && account?.isConnected) {
            window.web3Plugin._connectAccount = account.address;
        }
        else {
            window.web3Plugin._connectAccount = "Error3";
        }
    }
}

const isMetaMaskInstalled = (): boolean => {
    return typeof window.ethereum !== 'undefined' && window.ethereum.isMetaMask === true;
};

async function connect_Wagmi(name: string) {
    try {
        console.log("connect_Wagmi #1", {name});

        const connector = v2config.connectors.find((value) => {
            return value.name == name;
        });

        console.log("connect_Wagmi #2", window.web3ChainId, { connector });

        if (!connector) {
            throw new Error('Wagmi Connector not found!!!');
        }

        console.log("connect_Wagmi #3");
        if (name === "MetaMask") {
            await checkNetwork();
            console.log("connect_Wagmi #3");
        }

        const result = await connect(v2config, {
            chainId: window.web3ChainId,
            connector: connector!
        })

        window.web3Plugin.networkId = result.chainId;
        console.log("connect_Wagmi() >> web3Plugin.networkId : " + window.web3Plugin.networkId);
        await checkNetwork();

        const account = wagmiGetAccount();
        window.web3Plugin._connectAccount = account.address;
        console.log("connect_Wagmi() >> window.web3Plugin._connectAccount : " + window.web3Plugin._connectAccount);
    }
    catch (error: any) {
        const errmsg:string = error.message;
        console.log("connect_Wagmi() >> error : " + errmsg);
        window.web3Plugin._connectAccount = "Error : " + errmsg;
        if (name === "MetaMask" && isMetaMaskInstalled() === false) {
            window.open('https://metamask.io');
        }
    }

    WalletSelectModal.hide();
}


async function connect_Openfort() {
    WalletSelectModal.hide();

    try {
        await _authOpenfort();
        window.web3Plugin._connectAccount = window.web3Plugin._linkedAddress || "OPENFORT" + "0xopenfortfakeaddress";
        console.log("connect_Openfort() >> window.web3Plugin._connectAccount : " + window.web3Plugin._connectAccount);
        window.web3Plugin._walletProvider = "openfort";
    }
    catch (error: any) {
        console.log("connect_Openfort() >> error : " + error.message);
        window.web3Plugin._connectAccount = "Error : " + error.message;
    }
}

async function _disconnectAccount() {
    try {

        _MetaMaskConnector.options.shimDisconnect = true;

        await disconnect();

        window.localStorage.clear();

        window.web3Plugin._disconnectAccountResponse = "disconnect";
        window.web3Plugin._connectAccount = "";

    } catch (error: any) {
        window.web3Plugin._disconnectAccountResponse = error.message;
    }
}

async function _signMessage(message: string) {

    try {
        const signature = await signMessage({
            message: message,
        })

        window.web3Plugin._signMessageResponse = signature;
    } catch (error: any) {
        window.web3Plugin._signMessageResponse = "Error : " + error.message;
    }

    WalletSelectModal.hide();
}

async function _callContract(method: any, _abi: any, contract: any, _args: any) {
    console.log("method : " + method);
    console.log("abi : " + _abi);
    console.log("contract : " + contract);
    console.log(JSON.parse(_abi));
    console.log("args : " + _args);
    console.log(...JSON.parse(_args));

    try {
        await checkNetwork();

        var _abiJson = JSON.parse(_abi);
        var _argsJson = JSON.parse(_args);

        const data: any = await readContract({
            address: contract,
            abi: _abiJson,
            functionName: method,
            args: _argsJson,
            chainId: window.web3ChainId,
        })

        window.web3Plugin._callContractResponse = data.toString();
        console.log("_callContract >> data : " + data);
    } catch (error: any) {
        console.log("_callContract >> Error >> " + error);
        console.log("_callContract >> Error >> " + error.name);
        console.log("_callContract >> Error >> " + error.message);
        window.web3Plugin._callContractResponse = "Error : " + error.message.toString();
    }



    // .then((result) => window.web3Plugin._callContractResponse = result)
    // .catch((error) => window.web3Plugin._callContractResponse = error.message);


}

async function _sendContract(method: any, _abi: any, contract: any, _args: any, _value: any, _gasLimit: any, _gasPrice: any) {
    console.log("method : " + method);
    console.log("abi : " + _abi);
    console.log("contract : " + contract);
    console.log("_value : " + _value);
    console.log(JSON.parse(_abi));
    console.log("args : " + _args);
    console.log("args : " + JSON.parse(_args));

    try {
        await checkNetwork();

        if (method == "transfer") {
            const argsarr = JSON.parse(_args);
            const input = argsarr[1]; // Note: this is a string, e.g. user input
            console.log("input : " + input);
            const amount = String(parseUnits(input, 18));
            //const amount = parseEther(input);    
            argsarr[1] = amount;
            _args = JSON.stringify(argsarr);
            console.log("_args : " + _args);
        }

        var _abiJson = JSON.parse(_abi);
        var _argsJson = JSON.parse(_args);

        /*
            const feeData = await fetchFeeData({
              chainId: window.web3ChainId,
              formatUnits: 'gwei',
            })
            
            const gas = await publicClient.estimateContractGas({
              address: contract,
              abi: _abiJson,
              functionName: method,
              account: window.web3Plugin._connectAccount
            })
        
            console.log("feeData : " + feeData.gasPrice + " , " + feeData.maxPriorityFeePerGas);
          
            gasLimit = feeData.gasPrice;
            gasPrice = feeData.gasPrice;
            */
        const _gasPrice = getGasPrice();
        console.log({_gasPrice});
        const { request } = await prepareWriteContract({
            address: contract,
            abi: _abiJson,
            functionName: method,
            args: _argsJson,
            chainId: window.web3ChainId,
            value: _value,
            gasPrice: _gasPrice,
        })
        //console.log("gasLimit : " + gasLimit + " , gasPrice : " + web3.utils.toHex(gasPrice));
        const { hash } = await writeContract(request)
        console.log("writeContract Complete >> hash : " + hash + " , waitForTransaction Start");
        const data = await waitForTransaction({
            confirmations: 1,
            chainId: window.web3ChainId,
            hash: hash,
        })
        const stringified = JSON.stringify(data, replacer);
        console.log("waitForTransaction Complete >> data : " + stringified);
        console.log("data.status : " + data.status + " , data.transactionHash : " + data.transactionHash);

        if (data.status == 'success') {
            window.web3Plugin._sendContractResponse = data.transactionHash;
            console.log("_sendContract >> data.transactionHash : " + data.transactionHash);
        }
        else {
            window.web3Plugin._sendContractResponse = "ERR_waitForTransaction";
        }

    } catch (error: any) {

        console.log("_sendContract >> Error >> ", error);
        console.log("_sendContract >> Error name >> ", error.name);
        console.log("_sendContract >> Error message >> ", error.message);
        window.web3Plugin._sendContractResponse = error.message.toString();
    }

}

async function checkNetwork() {
    console.log(window.web3ChainId, window.web3Plugin._walletProvider);
    if (window.web3Plugin._walletProvider == "openfort") {
        console.log("===== checkNetwork() OPENFORT PASS")
        return;
    }

    const { chain, chains } = getNetwork();
    // console.log("checkNetwork 0 : " + JSON.stringify(chain)) + ", " + JSON.stringify(chains));
    console.log("checkNetwork 1 : " + chain?.id + ", " + window.web3ChainId);
    if (chain?.id != window.web3ChainId) {
        try {
            console.log("checkNetwork >> switchChain ", );
            console.log({v2config})
            console.log({ chain });
            await switchChain(v2config, {
                chainId: window.web3ChainId,
            })
        } catch (ex: any) {
            console.log({ex});
            if (ex.code != 4001) { // 4001 user reject
                await addEthereumChain();
            }
        }
    }
}

// add new wallet to in metamask
async function addEthereumChain() {
    console.log("checkNetwork >> addEthereumChain ");
    //const account = (await web3.eth.getAccounts())[0];
    // const account = getAccount();
    // console.log("account : " + JSON.stringify(account));
    // fetch https://chainid.network/chains.json
    // const response = await fetch("https://chainid.network/chains.json");
    // const chains = await response.json();

    // find chain with network id
    const chain = supportedChains.find((chain: any) => chain.id == window.web3ChainId);

    if (!!chain)
    {
        const rpcUrl = chain.rpcUrls?.default?.http ? chain.rpcUrls.default.http : '';
        const blockExplorerUrl = chain.blockExplorers?.default?.url ? [chain.blockExplorers.default.url] : [];
        
        if (rpcUrl === '' || !blockExplorerUrl.length)
        {
            const missing = [];

            if (rpcUrl === '') 
            {
                missing.push("RPC URL");
            }

            if (!blockExplorerUrl.length)
            {
                missing.push("Block Explorer URL");
            }

            console.error(`addEthereumChain >> Error: ${missing.join(" and ")} not found for chain ${chain.name}`);

            return;
        }

        const params = {
            chainId: "0x" + chain.id.toString(16), // A 0x-prefixed hexadecimal string
            chainName: chain.name,
            nativeCurrency: {
                name: chain.nativeCurrency.name,
                symbol: chain.nativeCurrency.symbol, // 2-6 characters long
                decimals: chain.nativeCurrency.decimals,
            },
            rpcUrls: rpcUrl,
            blockExplorerUrls: blockExplorerUrl,
        };
    
        await window.ethereum
            .request({
                method: 'wallet_addEthereumChain',
                //params: [params, account],
                params: [params],
            })
            .catch((error: any) => {
                // I give up
                console.error("addEthereumChain >> Error : ", error);
                //window.location.reload();
            });
    }
    else {
        console.error("addEthereumChain >> Error : Chain not found for id " + window.web3ChainId);
    }
}

const replacer = (_key: any, value: any) =>
    typeof value === "bigint" ? value.toString() : value;

const reviver = (key: any, value: any) => (key === "big" ? BigInt(value) : value);

// << Function
// ================================================================
// >> Watch
const checkAccount = function (account: any) {
    console.log("==========----------==========");
    console.log("watchAccount > " + account);
    console.log({ account })

    if (window.web3Plugin._walletProvider == "openfort") {
        console.log("===== watchAccount() OPENFORT PASS")
        return;
    }

    if (account.isConnected) {
        console.log(account);
        console.log("account.address : " + account.address);
        if (window.web3Plugin._connectAccount != "" && account.address != window.web3Plugin._connectAccount) {
            window.web3Plugin._connectAccount = account.address;
            window.location.reload();
        }
        else if (window.web3ChainId && window.web3ChainId != account.chainId) {
            window.location.reload();
        }
        else {
            window.web3Plugin._connectAccount = account.address;
            window.web3ChainId = account.chainId;
        }

        _MetaMaskConnector.options.shimDisconnect = false;
    }
    else {
        window.web3Plugin._connectAccount = "";
    }

    // watchNetwork depricated in v2
    window.web3Plugin.networkId = account.chainId;
}

const setWatchAccount = function () {
    checkAccount(getAccount(v2config));
    return watchAccount(v2config, {
        onChange(account: any) {
            checkAccount(account);
        }
    })
}

const unwatchAccount = setWatchAccount();

// ================================================================

// ================================================================
// >> InputField Modal
const inputModal: HTMLElement = document.querySelector("#input-modal")!;
let ConfirmInput = 0;

const InputModal_InputField: any = document.querySelector("#InputModal_InputField")!;
// options with default values
const inputModal_options: ModalOptions = {
    placement: 'center',
    backdropClasses: 'bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-40',
    onHide: () => {
        console.log('inputModal is hidden');
        if (ConfirmInput != 1) {
            window.web3Plugin._openInputModalResponse = "$_BLANK_$";
            ConfirmInput = 0;
        }
    },
    onShow: () => {
        console.log('inputModal is shown');
        ConfirmInput = 0;
        InputModal_InputField.focus();
    },
    onToggle: () => {
        console.log('inputModal has been toggled');
    }
};

const InputModal = new Modal(inputModal, inputModal_options);

const InputModalCloseButton = document.querySelector("#InputModalCloseButton")!;
InputModalCloseButton.addEventListener('click', () => {
    console.log("Click");
    window.web3Plugin._openInputModalResponse = "$_BLANK_$";
    InputModal.toggle();
})

async function _openInputModal() {
    InputModal_InputField.value = "";
    InputModal.toggle();
}

const InputModal_SubmitButton: any = document.querySelector("#InputModal_SubmitButton")!;
InputModal_SubmitButton.addEventListener('click', () => {
    console.log("InputModal_InputField.value : " + InputModal_InputField.value);

    ConfirmInput = 1;
    if (InputModal_InputField.value != "")
        window.web3Plugin._openInputModalResponse = InputModal_InputField.value;
    else
        window.web3Plugin._openInputModalResponse = "$_BLANK_$";

    console.log("window.web3Plugin._openInputModalResponse : " + window.web3Plugin._openInputModalResponse);
    InputModal.toggle();
})

InputModal_InputField.addEventListener("keyup", function (event: any) {
    if (event.keyCode === 13) {
        event.preventDefault();
        InputModal_SubmitButton.click();
    }
});
// ================================================================
try {
    // Your web app's Firebase configuration
    // For Firebase JS SDK v7.20.0 and later, measurementId is optional
    const firebaseApp = firebase.initializeApp({
        // apiKey: "AIzaSyCEt19mYwJQPhT7-86klXPs6il_1e3VFd4",
        // authDomain: "kingdom-nft-dev.firebaseapp.com",
        // projectId: "kingdom-nft-dev",
        // storageBucket: "kingdom-nft-dev.appspot.com",
        // messagingSenderId: "382291140510",
        // appId: "1:382291140510:web:c237e68c961047b124008f",
        // measurementId: "G-9GK7MHT5TJ"
        apiKey: "{{{ FIREBASE_API_KEY }}}",
        authDomain: "{{{ FIREBASE_AUTH_DOMAIN }}}",
        projectId: "{{{ FIREBASE_PROJECT_ID }}}",
        storageBucket: "{{{ FIREBASE_STORAGE_BUCKET }}}",
        messagingSenderId: "{{{ FIREBASE_MASSAGING_SENDER_ID }}}",
        appId: "{{{ FIREBASE_APP_ID }}}",
        measurementId: "{{{ FIREBASE_MEASUREMENT_ID }}}",
    });

    // Initialize Firebase
    window.auth = firebaseApp.auth!();
    // Initialize Analytics and get a reference to the service
    const analytics = firebaseApp.analytics();

    // Initialize Firebase Cloud Messaging and get a reference to the service
    const messaging = firebaseApp.messaging();
    // Add the public key generated from the console here.
    //messaging.getToken(messaging, {vapidKey: "BLWnD7vSyzPlJh8EDjh_p0Jt-H1ALhDtmXNu8R25gTLMiEZ288rG7DD-MSeBcCfAffT7cqJWFCha2DzEF28b-Do"}).then((currentToken) => {
    messaging.getToken({ vapidKey: "{{{ FIREBASE_WEB_PUSH_ID }}}" }).then((currentToken) => {

        if (currentToken) {
            // Send the token to your server and update the UI if necessary
            // ...
            console.log('messaging >> Get FCM Token Sucess : ' + currentToken);
            window.web3Plugin._fcmToken = currentToken;
            localStorage.setItem('fcm', currentToken);
        } else {
            // Show permission request UI
            console.log('messaging >> No registration token available. Request permission to generate one.');
            window.web3Plugin._fcmToken = "";
            // ...
        }
    }).catch((err) => {
        console.log('messaging >> An error occurred while retrieving token. ', err);
        window.web3Plugin._fcmToken = "";
        // ...
    });

    messaging.onMessage((payload: any) => {
        console.log('Message received. ', payload);
        var title = payload.notification.title;
        var options = {
            body: payload.notification.body,
            icon: '/img/Win_96x96.png'
        };
        //alert("알람발생");
        var notification = new Notification(title, options);
    });

    window.googleProvider = new firebase.auth.GoogleAuthProvider();
    window.facebookProvider = new firebase.auth.FacebookAuthProvider();

} catch (err) {
    console.error(err)
}


// ================================================================

async function _openfortProc(functionName: any, jsonData: any) {
    console.log("==========----------==========");
    console.log({ functionName });
    console.log({ jsonData });

    if (functionName == "SetLinkedAddress") {
        await _resetWeb3(jsonData.linkedAddress, jsonData.walletProvider);

        window.web3Plugin._walletProvider = jsonData.walletProvider;
        window.web3Plugin._linkedAddress = jsonData.linkedAddress;
        if (jsonData.walletProvider == "openfort") {
            window.web3Plugin._connectAccount = jsonData.linkedAddress;
            try {
                await _authOpenfort();
            } catch (ex) {
                console.error(ex);
            }
        }

        return {
            walletProvider: window.web3Plugin._walletProvider,
            linkedAddress: window.web3Plugin._linkedAddress,
        }
    } else if (functionName == "SetChainID") {
        window.web3ChainId = jsonData.chainId;
        OFSetChainId(jsonData.chainId, setWatchAccount, unwatchAccount);
        const openfortChainId = OFGetChainId();
        console.log({ openfortChainId });
        return {
            web3ChainId: window.web3ChainId
        }
    } else if (functionName == "SendTransaction") {
        const openfort = OFGetOpenfort();
        console.log({ openfort });

        if (!openfort) {
            throw "openfort not initialized";
        }

        let transactionIntent = JSON.parse(jsonData.transactionIntent);
        console.log({ transactionIntent });
        console.log("----->>>>>", "OFsendTransaction()", transactionIntent.nextAction);

        const sender = transactionIntent.userOperation.sender;
        await _verifyBalance(sender);

        const response = await OFsendTransaction(transactionIntent);
        console.log({ response });
        const error = response.response.error;
        if (error) {
            throw error.reason;
        }
        if (response.response?.transactionHash == null) {
            throw "Error : Null Transaction";
        }

        const txHash = response.response?.transactionHash;

        console.log("=====-----===== OFsendTransaction Complete >> hash : " + txHash + " , waitForTransaction Start");
        const data = await waitForTransaction({
            confirmations: 1,
            chainId: window.web3ChainId,
            hash: txHash,
        })
        const stringified = JSON.stringify(data, replacer);
        console.log("=====-----===== waitForTransaction Complete >> data : " + stringified);
        console.log("=====-----===== data.status : " + data.status + " , data.transactionHash : " + data.transactionHash);

        if (data.status == 'success') {
            window.web3Plugin._sendContractResponse = data.transactionHash;
            console.log("=====-----===== OFsendTransaction >> data.transactionHash : " + data.transactionHash);
        }
        else {
            window.web3Plugin._sendContractResponse = "ERR_waitForTransaction";
        }

        return {
            txHash: window.web3Plugin._sendContractResponse
        }
    } else if (functionName == "GetIdentityToken") {
        const user = window.auth.currentUser;
        let identityToken = "";
        if (user) {
            identityToken = await user.getIdToken();
        }
        return {
            idToken: identityToken
        }
    } else if (functionName == "SetOpenfortConfig") {
        const publicKey = jsonData.publicKey;
        const shieldApiKey = jsonData.shieldApiKey;
        const shieldEncryptionShare = jsonData.shieldEncryptionShare;
        OFInitialize(
            publicKey,
            shieldApiKey,
            shieldEncryptionShare
        )

        if (window.web3Plugin._walletProvider == "openfort") {
            try {
                const signTest = await _authOpenfort();
                return {
                    signTest: signTest
                }
            } catch (ex) {
                throw ex;
            }
        } else {
            return {
                message: "provider is not openfort"
            }
        }
    } else if (functionName == "OpenRamp") {
        // console.log("OpenRamp");
        // try {
        //     var userAddress = jsonData.userAddress;
        //     console.log("userAddress " + userAddress);

        //     const result = await OpenRamp(userAddress, (type, data) => {
        //         console.log('type', type, 'data', JSON.parse(data));
        //     });

        //     const error = result.response.error;

        //     return {
        //         message: result
        //     }
        // }
        // catch (error: any) {
        //     return {
        //         message: "OpenRamp fail"
        //     }
        // }
    } else if (functionName == "GetBalance") {
        console.log("GetBalance");
        try {
            var userAddress = jsonData.userAddress;
            console.log("userAddress " + userAddress);

            const result = await _verifyBalance(userAddress);

            return {
                message: result
            }
        }
        catch (error: any) {
            return {
                message: "GetBalance fail"
            }
        }
    }

    console.log("==========----------==========");
}

async function _authOpenfort() {
    const openfort = OFGetOpenfort();
    console.log({ openfort });

    if (!openfort) {
        throw "openfort not initialized";
    }

    try {
        const user = window.auth.currentUser;
        const identityToken = await user.getIdToken();
        console.log(1, { identityToken });
        const result = await OFauthenticateWithThirdPartyProvider(identityToken);
        console.log(2, { result });

        const status1 = OFgetEmbeddedState();
        console.log(3, { status1 });

        if (status1 != 4) {
            const result2 = await OFsetAutomaticRecoveryMethod(identityToken);
            console.log(4, { result2 });
            const status2 = OFgetEmbeddedState();
            console.log(5, { status2 });
        }
    } catch (ex) {
        console.error(ex);
        await OFlogout();
    }

    const signTest = await OFsignMessage("kingdom");
    console.log({ signTest });

    return signTest;
}

async function _disconnectOpenfort() {
    const openfort = OFGetOpenfort();
    console.log({ openfort });

    if (openfort) {
        await OFlogout();
    } else {
        console.log("openfort not initialized");
    }
}

async function _disconnectWeb3() {
    const wagmiAccount = await wagmiGetAccount();
    console.log({ wagmiAccount });
    if (wagmiAccount?.isConnected) {
        _MetaMaskConnector.options.shimDisconnect = true;
        await disconnect();
    }
}

async function _resetWeb3(address: any, provider: any) {
    console.log("_resetWeb3", address, provider);
    address = "" + address;
    if (address == "") {
        await _disconnectOpenfort();
        await _disconnectWeb3();
    } else {
        if (provider == "openfort") {
            await _disconnectWeb3();
        } else {
            await _disconnectOpenfort();
        }
    }

    await reconnect(v2config);
    const wagmiAccount = await wagmiGetAccount();
    console.log('after', { wagmiAccount });
}

async function _verifyBalance(address: any) {
    const chainId = window.web3ChainId;
    console.log({ address, chainId })
    const balance = await fetchBalance({ address, chainId });
    console.log({ balance });
    if (balance.value < 1000000000000000n) {
        // throw new Error("Insufficient BNB Balance!");
    }

    return balance.formatted;
}



// new features

async function InitChainNames(chainIdList: string[]) {
    chainNames = [];
    
    for (const chainId of chainIdList) {
        chainNames.push(getChainNameById(chainId));
    }

    console.log("InitChainNames", chainNames.join(', '));
}

async function GetBrowserChainId() {
    try {
        const account = wagmiGetAccount();
        console.log("GetBrowserChainId", {account});
        if (account != null && account?.chainId !== undefined) {
            const chainId = account?.chainId;
            window.web3Plugin._getBrowserChainIdResponse = chainId.toString();
        } else {
            window.web3Plugin._getBrowserChainIdResponse = "0";
        }
    } catch (error: any) {
        window.web3Plugin._signMessageResponse = "Error : " + error.message;
    }
}

async function switchBrowserChain(chainId: string) {
    try {
        console.log("switchBrowserChain", chainId);
        window.web3ChainId = Number.parseInt(chainId);
        await checkNetwork();
    } catch (error: any) {
        window.web3Plugin._signMessageResponse = "Error : " + error.message;
    }
}
